import { LineChart } from '@mui/x-charts/LineChart';
import ChartCard from '../../analytics/ChartCard';
import { RequestRateDataPoint } from '../../../../types/admin';

interface RequestRateChartProps {
  data: RequestRateDataPoint[];
  loading?: boolean;
}

export default function RequestRateChart({ data, loading }: RequestRateChartProps) {
  const timestamps = data.map((d) => new Date(d.timestamp));
  const requests = data.map((d) => d.requests);

  return (
    <ChartCard title="Request Rate" subtitle="Requests per minute over last 24 hours" loading={loading} height={400}>
      <LineChart
        xAxis={[
          {
            data: timestamps,
            scaleType: 'time',
            valueFormatter: (date) =>
              new Date(date).toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              }),
          },
        ]}
        yAxis={[
          {
            label: 'Requests/min',
          },
        ]}
        series={[
          {
            data: requests,
            label: 'Request Rate',
            color: '#1976d2',
            showMark: false,
            area: true,
          },
        ]}
        grid={{ vertical: false, horizontal: true }}
        sx={{
          '& .MuiLineElement-root': {
            strokeWidth: 2,
          },
        }}
      />
    </ChartCard>
  );
}
